// tslint:disable: trailing-comma
// tslint:disable:no-any
import { Unit } from '../common';

export interface UnitsResponse {
  links: any;
  productUnitConversions: {
    links: any
    productUnitConversionId: number
    product: {
      links: any
      productId: number
    }
    alternativeUnit: Unit
    baseUnit: Unit
    denominator: number
    numerator: number
  }[];
  count: number;
  totalCount: number;
}
